'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botManager = require('./bot-manager.html');

var _botManager2 = _interopRequireDefault(_botManager);

var _botManager3 = require('./bot-manager.controller');

var _botManager4 = _interopRequireDefault(_botManager3);

require('./bot-manager.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botManagerComponent = {
  restrict: 'E',
  bindings: {},
  template: _botManager2.default,
  controller: _botManager4.default,
  controllerAs: 'vm'
};

exports.default = botManagerComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-manager/bot-manager.component.js
 **/